export function isIOS() {
  return /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && navigator.maxTouchPoints;
}
export function setOverflowHidden(value = true) {
  if (value) {
    document.body.style.overflowY = 'hidden';
    if (isIOS()) {
      const offsetY = window.pageYOffset;
      document.body.dataset.top = `${offsetY}px`;
      document.body.style.position = 'fixed';
    }
  } else {
    document.body.style.overflowY = 'initial';
    if (isIOS()) {
      const offsetY = Math.abs(parseInt(document.body.dataset.top || '0', 10));
      document.body.style.position = 'relative';
      window.scrollTo({
        left: 0,
        top: offsetY || 0,
        behavior: 'instant',
      });
    }
  }
}
